import { render, staticRenderFns } from "./ConversionRow.vue?vue&type=template&id=a23e7c56&scoped=true&"
import script from "./ConversionRow.vue?vue&type=script&lang=ts&"
export * from "./ConversionRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23e7c56",
  null
  
)

export default component.exports